const KEY_PREFIX = "salonos.servicesCatalog.collapsedCategories";

function keyFor(companyId: string): string {
  return `${KEY_PREFIX}.${companyId}`;
}

export function readCollapsedCategories(companyId: string | null | undefined): Set<string> {
  if (!companyId) return new Set();
  try {
    const raw = localStorage.getItem(keyFor(companyId));
    if (!raw) return new Set();
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed) || !parsed.every((id) => typeof id === "string")) {
      localStorage.removeItem(keyFor(companyId)); // self-heal a malformed value (S5)
      return new Set();
    }
    return new Set(parsed as string[]);
  } catch {
    return new Set();
  }
}

export function persistCollapsedCategories(
  companyId: string | null | undefined,
  ids: Set<string>,
): void {
  if (!companyId) return;
  try {
    localStorage.setItem(keyFor(companyId), JSON.stringify([...ids]));
  } catch {
    // private mode / quota — persistence is non-critical, in-session collapse still works
  }
}
